import { Button, Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import "./NotFound.scss";

export default function NotFound() {
    return (
        <div className="not-found-page">
            <Container>

                <h2>Page Not Found</h2>
                <p>We were unable to find this page.</p>
                <p>
                    <LinkContainer to="/home">
                        <Button variant="primary">Go Home</Button>
                    </LinkContainer>
                </p>
            </Container>
        </div>
    )    
}